import React from 'react';
import styled from 'styled-components';
import Box from '../../spa/core-components/Box';
import { BoxProps } from '../../spa/core-components/Box/Box';

interface Props extends BoxProps {
    children: React.ReactNode;
}

const StyledBox = styled(Box as any)`
    position: absolute;
    width: 100%;
    bottom: 0;
`;

const Gradient = styled.div`
    &:before {
        content: '';
        position: absolute;
        background-image: linear-gradient(to top, rgba(28, 27, 26, 0.8), transparent 100%);
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
    }
`;

const Inner = styled.div`
    position: relative;
`;

export default function BoxWithGradient({ children, ...props }: Props) {
    return (
        <StyledBox {...props}>
            <Gradient>
                <Inner>{children}</Inner>
            </Gradient>
        </StyledBox>
    );
}
